import { Component, computed, input, model, output } from '@angular/core';

import { ContentBuilderFieldColors } from '@shared/interfaces/content-builder.interface';
import { getAllCountries } from '@shared/components/input-country-phone/config/countries.config';

import { appendE164Digit, isE164Phone } from '../pongo-phone.util';

@Component({
  selector: 'app-pongo-kiosk-phone-form',
  templateUrl: './pongo-kiosk-phone-form.component.html',
  standalone: false,
})
export class PongoKioskPhoneFormComponent {
  readonly titleKey = input.required<string>();
  readonly labelKey = input.required<string>();
  readonly helpKey = input<string>();
  readonly phone = model('');
  readonly defaultRegionCode = input('fr');
  readonly isValidating = input(false);
  readonly errorMessage = input<string>();
  readonly accentColor = input<ContentBuilderFieldColors>();

  readonly submitPhone = output<string>();
  readonly onClose = output<Event>();

  readonly canSubmit = computed(() => !this.isValidating() && isE164Phone(this.phone()));

  onKeypadNumberClick(digit: number): void {
    this.phone.set(appendE164Digit(this.phone(), digit, this.dialCodePrefix()));
  }

  onKeypadDeleteClick(): void {
    const current = this.phone();
    const dialCode = this.dialCodePrefix();
    if (!current || current.length <= dialCode.length || current === dialCode) {
      return;
    }
    this.phone.set(current.slice(0, -1));
  }

  onSubmit(): void {
    if (!this.canSubmit()) {
      return;
    }
    this.submitPhone.emit(this.phone());
  }

  private dialCodePrefix(): string {
    const phone = this.phone();
    if (phone.startsWith('+')) {
      const matched = getAllCountries()
        .map(country => `+${country.dialCode}`)
        .filter(prefix => phone.startsWith(prefix))
        .sort((left, right) => right.length - left.length)[0];
      if (matched) {
        return matched;
      }
    }

    const region = (this.defaultRegionCode() || 'fr').toLowerCase();
    const country = getAllCountries().find(item => item.iso2.toLowerCase() === region);
    return country ? `+${country.dialCode}` : '+33';
  }
}
